import { render, staticRenderFns } from "./InformationPanel.vue?vue&type=template&id=5efdc8d9&scoped=true&"
import script from "./InformationPanel.vue?vue&type=script&lang=js&"
export * from "./InformationPanel.vue?vue&type=script&lang=js&"
import style0 from "./InformationPanel.vue?vue&type=style&index=0&id=5efdc8d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efdc8d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VAlert,VBtn})
